export default angular
  .module('doxy.common.directives.favicon', [])
  .directive('favicon', function ($rootScope, pn, globalUi, institutionHelper, User) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, $element, attrs) {
        let data = {
          textCountUnread: '0',
          patientsCount: 0,
          hrefHistory: {},
          initialHref: attrs.href,
          faviconSize: 16,
          rates: {
            0: 0.17,
            '9+': 0.35,
            default: 0.3,
          },
          fontSize: 8,
        };

        const hrefHistoryKey = () => {
          if (data.textCountUnread !== '0')
            return `messagesCount${data.textCountUnread}`;
          if (data.patientsCount) return `patientsInRoom`;
          return 'default';
        };

        data.hrefHistory[hrefHistoryKey()] = attrs.href;

        const shouldUseLightInstitution = !User.isAuthenticated();

        institutionHelper
          .getCurrentInstitution(shouldUseLightInstitution)
          .then((institution) => {
            if (!institution.favicon) return;
            data.hrefHistory.default = institution.favicon;
            data.initialHref = institution.favicon;
          })
          .catch((err) => {
            console.warn('favicon getCurrentInstitution error', {
              status: err?.status,
              statusText: err?.statusText,
              xhrStatus: err?.xhrStatus,
              url: err?.config?.url,
              params: err?.config?.params,
            });
          });

        const renderFavicon = (href) => {
          if (!href) {
            const img = document.createElement('img');
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const rate = data.rates[data.textCountUnread] || data.rates.default;

            canvas.width = data.faviconSize;
            canvas.height = data.faviconSize;
            img.setAttribute('crossorigin', 'anonymous');
            img.src = data.initialHref + '?xcrossorigin=anonymous'; // random parameter to bust cors headers cache

            img.onload = () => {
              context.drawImage(img, 0, 0, data.faviconSize, data.faviconSize);
              let r = data.faviconSize * rate + 1;
              let x = data.faviconSize - r;
              let y = r;
              ['#FFFFFF', '#FF0000'].forEach((color) => {
                context.beginPath();
                context.arc(x, y, r, 0, 2 * Math.PI);
                context.fillStyle = color;
                context.fill();
                r--;
              });

              if (data.textCountUnread !== '0') {
                context.font = 'bold ' + data.fontSize + 'px arial';
                context.textAlign = 'center';
                context.textBaseline = 'middle';
                context.fillStyle = '#FFFFFF';
                context.fillText(
                  data.textCountUnread,
                  data.faviconSize - r - 2,
                  r + 2
                );
              }
              href = canvas.toDataURL('image/png');
              data.hrefHistory[hrefHistoryKey()] = href;
              $element.attr('href', href);
            };
          } else {
            $element.attr('href', href);
          }
        };

        const handleEvents = function () {
          if (pn.isDoctor()) {
            data.textCountUnread =
              globalUi.ui.newMessages > 9 ? '9+' : globalUi.ui.newMessages + '';
            data.patientsCount = pn.people.getPatients().length;
            const href = data.hrefHistory[hrefHistoryKey()] || false;
            if ($element.attr('href') !== href) {
              renderFavicon(href);
            }
          }
        };

        pn.on('join', handleEvents);
        pn.on('leave', handleEvents);
        pn.on('forceRemove', handleEvents);
        $rootScope.$on('globalUi:newMessages', handleEvents);
      },
    };
  }).name;
